var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconPhoto = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 37,
  height: 29,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#4264FD",
  fillRule: "evenodd",
  d: "m25.795 3.894.002-.07v-1.65c0-1.2-1.48-2.174-3.3-2.174h-7.995c-1.82 0-3.298.974-3.298 2.174v1.65q0 .036.002.07H2.17A2.173 2.173 0 0 0 0 6.068v20.758C0 28.026.973 29 2.171 29H34.83A2.173 2.173 0 0 0 37 26.826V6.068c0-1.2-.973-2.174-2.171-2.174zM10.993 16.447c0 4.15 3.363 7.515 7.507 7.515a7.51 7.51 0 0 0 7.504-7.515c0-4.148-3.359-7.513-7.504-7.513-4.146 0-7.507 3.365-7.507 7.513m13.284.002a5.78 5.78 0 0 1-5.776 5.781 5.777 5.777 0 0 1-5.774-5.78 5.777 5.777 0 0 1 5.774-5.783 5.78 5.78 0 0 1 5.776 5.782",
  clipRule: "evenodd"
})));
export default SvgIconPhoto;